<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AT4"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="VOLUME ONE">
<table id="pz45-16"><tbody><tr>
<td class="tb_1 ola3" id="pz9-1">1</td>
<td>Compliment three people every day.</td>
</tr>
<tr>
<td class="ola3" id="pz9-2">2</td>
<td>Have a dog.</td>
</tr>
<tr>
<td class="ola3" id="pz9-3">3</td>
<td>Watch a sunrise at least once a year.</td>
</tr>
<tr>
<td class="ola3" id="pz9-4">4</td>
<td>Remember other people’s birthdays.</td>
</tr>
<tr>
<td class="ola3" id="pz9-5">5</td>
<td>Overtip breakfast waitresses.</td>
</tr>
<tr>
<td class="ola3" id="pz9-6">6</td>
<td>Have a firm handshake.</td>
</tr>
<tr>
<td class="ola3" id="pz9-7">7</td>
<td>Look people in the eye.</td>
</tr>
<tr>
<td class="ola3" id="pz9-8">8</td>
<td>Say “thank you” a lot.</td>
</tr>
<tr>
<td class="ola3" id="pz9-9">9</td>
<td>Say “please” a lot.</td>
</tr>
<tr>
<td class="ola3" id="pz10-1">10</td>
<td>Learn to play a musical instrument.</td>
</tr>
<tr>
<td class="ola3" id="pz10-2">11</td>
<td>Sing in the shower.</td>
</tr>
<tr>
<td class="ola3" id="pz10-3">12</td>
<td>Use the good silver.</td>
</tr>
<tr>
<td class="ola3" id="pz10-4">13</td>
<td>Learn to make great chili.</td>
</tr>
<tr>
<td class="ola3" id="pz10-5">14</td>
<td>Plant flowers every spring.</td>
</tr>
<tr>
<td class="ola3" id="pz10-6">15</td>
<td>Own a great stereo system.</td>
</tr>
<tr>
<td class="ola3" id="pz10-7">16</td>
<td>Be the first to say, “Hello.”</td>
</tr>
<tr>
<td class="ola3" id="pz10-8">17</td>
<td>Live beneath your means.</td>
</tr>
<tr>
<td class="ola3" id="pz10-9">18</td>
<td>Buy great books, even if you never read them.</td>
</tr>
<tr>
<td class="ola3" id="pz11-1">19</td>
<td>Drive inexpensive cars, but own the best house you can afford.</td>
</tr>
<tr>
<td class="ola3" id="pz11-2">20</td>
<td>Be forgiving of yourself and others.</td>
</tr>
<tr>
<td class="ola3" id="pz11-3">21</td>
<td>Learn three clean jokes.</td>
</tr>
<tr>
<td class="ola3" id="pz11-4">22</td>
<td>Wear polished shoes.</td>
</tr>
<tr>
<td class="ola3" id="pz11-5">23</td>
<td>Floss your teeth.</td>
</tr>
<tr>
<td class="ola3" id="pz11-6">24</td>
<td>Drink champagne for no reason at all.</td>
</tr>
<tr>
<td class="ola3" id="pz11-7">25</td>
<td>Ask for a raise when you feel you’ve earned it.</td>
</tr>
<tr>
<td class="ola3" id="pz11-8">26</td>
<td>Buy whatever kids are selling on card tables in their front yard.</td>
</tr>
<tr>
<td class="ola3" id="pz12-1">27</td>
<td>If in a fight, hit first and hit hard.</td>
</tr>
<tr>
<td class="ola3" id="pz12-2">28</td>
<td>Return all the things you borrow.</td>
</tr>
<tr>
<td class="ola3" id="pz12-3">29</td>
<td>Teach some kind of class.</td>
</tr>
<tr>
<td class="ola3" id="pz12-4">30</td>
<td>Be a student in some kind of class.</td>
</tr>
<tr>
<td class="ola3" id="pz12-5">31</td>
<td>Never buy a house without a fireplace.</td>
</tr>
<tr>
<td class="ola3" id="pz12-6">32</td>
<td>Once in your life own a convertible.</td>
</tr>
<tr>
<td class="ola3" id="pz12-7">33</td>
<td>Treat everyone you meet like you want to be treated.</td>
</tr>
<tr>
<td class="ola3" id="pz12-8">34</td>
<td>Learn to identify the music of Chopin, Mozart, and Beethoven.</td>
</tr>
<tr>
<td class="ola3" id="pz13-1">35</td>
<td>Plant a tree on your birthday.</td>
</tr>
<tr>
<td class="ola3" id="pz13-2">36</td>
<td>Donate two pints of blood every year.</td>
</tr>
<tr>
<td class="ola3" id="pz13-3">37</td>
<td>Make new friends but cherish the old ones.</td>
</tr>
<tr>
<td class="ola3" id="pz13-4">38</td>
<td>Keep secrets.</td>
</tr>
<tr>
<td class="ola3" id="pz13-5">39</td>
<td>Take lots of snapshots.</td>
</tr>
<tr>
<td class="ola3" id="pz13-6">40</td>
<td>Never refuse homemade brownies.</td>
</tr>
<tr>
<td class="ola3" id="pz13-7">41</td>
<td>Don’t postpone joy.</td>
</tr>
<tr>
<td class="ola3" id="pz13-8">42</td>
<td>Ask someone to pick up your mail and daily paper when you’re out of town. Those are the first two things potential burglars look for.</td>
</tr>
<tr>
<td class="ola3" id="pz14-1">43</td>
<td>
<span class="tb_2">Never give up on anybody. Miracles happen every day.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz15-1">44</td>
<td>Write “thank you” notes promptly.</td>
</tr>
<tr>
<td class="ola3" id="pz15-2">45</td>
<td>Show respect for teachers.</td>
</tr>
<tr>
<td class="ola3" id="pz15-3">46</td>
<td>Show respect for police officers and firefighters.</td>
</tr>
<tr>
<td class="ola3" id="pz15-4">47</td>
<td>Show respect for military personnel.</td>
</tr>
<tr>
<td class="ola3" id="pz15-5">48</td>
<td>Don’t waste time learning the “tricks of the trade.” Instead, learn the trade.</td>
</tr>
<tr>
<td class="ola3" id="pz15-7">49</td>
<td>Keep a tight rein on your temper.</td>
</tr>
<tr>
<td class="ola3" id="pz15-8">50</td>
<td>Buy vegetables from truck farmers who advertise with hand-lettered signs.</td>
</tr>
<tr>
<td class="ola3" id="pz15-10">51</td>
<td>Put the cap back on the toothpaste.</td>
</tr>
<tr>
<td class="ola3" id="pz16-1">52</td>
<td>Take out the garbage without being told.</td>
</tr>
<tr>
<td class="ola3" id="pz16-2">53</td>
<td>Avoid overexposure to the sun.</td>
</tr>
<tr>
<td class="ola3" id="pz16-3">54</td>
<td>Vote.</td>
</tr>
<tr>
<td class="ola3" id="pz16-4">55</td>
<td>Surprise loved ones with little unexpected gifts.</td>
</tr>
<tr>
<td class="ola3" id="pz16-5">56</td>
<td>Stop blaming others. Take responsibility for every area of your life.</td>
</tr>
<tr>
<td class="ola3" id="pz16-7">57</td>
<td>Never mention being on a diet.</td>
</tr>
<tr>
<td class="ola3" id="pz16-8">58</td>
<td>Make the best of bad situations.</td>
</tr>
<tr>
<td class="ola3" id="pz16-9">59</td>
<td>Learn to make something beautiful with your hands.</td>
</tr>
<tr>
<td class="ola3" id="pz17-1">60</td>
<td>Live so that when your children think of fairness, caring, and integrity, they think of you.</td>
</tr>
<tr>
<td class="ola3" id="pz17-2">61</td>
<td>Support a high school band.</td>
</tr>
<tr>
<td class="ola3" id="pz17-3">62</td>
<td>Admit your mistakes.</td>
</tr>
<tr>
<td class="ola3" id="pz17-4">63</td>
<td>Use your wit to amuse, not abuse.</td>
</tr>
<tr>
<td class="ola3" id="pz17-5">64</td>
<td>Remember that all news is biased.</td>
</tr>
<tr>
<td class="ola3" id="pz17-6">65</td>
<td>Take a photography course.</td>
</tr>
<tr>
<td class="ola3" id="pz17-7">66</td>
<td>Let people pull in front of you when you’re stopped in traffic.</td>
</tr>
<tr>
<td class="ola3" id="pz17-9">67</td>
<td>Always accept an outstretched hand.</td>
</tr>
<tr>
<td class="ola3" id="pz18-1">68</td>
<td>
<span class="tb_2">Be brave. Even if you’re not, pretend to be. No one can tell the difference.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz19-1">69</td>
<td>Demand excellence and be willing to pay for it.</td>
</tr>
<tr>
<td class="ola3" id="pz19-2">70</td>
<td>Whistle.</td>
</tr>
<tr>
<td class="ola3" id="pz19-3">71</td>
<td>Hug children after you discipline them.</td>
</tr>
<tr>
<td class="ola3" id="pz19-4">72</td>
<td>Give to charity all the clothes you haven’t worn during the past three years.</td>
</tr>
<tr>
<td class="ola3" id="pz19-6">73</td>
<td>Never forget your anniversary.</td>
</tr>
<tr>
<td class="ola3" id="pz19-7">74</td>
<td>Eat prunes.</td>
</tr>
<tr>
<td class="ola3" id="pz19-8">75</td>
<td>Ride a bike.</td>
</tr>
<tr>
<td class="ola3" id="pz19-9">76</td>
<td>Choose a charity in your community and support it generously with your time and money.</td>
</tr>
<tr>
<td class="ola3" id="pz20-1">77</td>
<td>Slow dance.</td>
</tr>
<tr>
<td class="ola3" id="pz20-2">78</td>
<td>Steer clear of restaurants with strolling musicians.</td>
</tr>
<tr>
<td class="ola3" id="pz20-4">79</td>
<td>Don’t take good health for granted.</td>
</tr>
<tr>
<td class="ola3" id="pz20-5">80</td>
<td>When someone wants to hire you, even if it’s for a job you have little interest in, talk to them. Never close the door on an opportunity until you’ve had a chance to hear the offer in person.</td>
</tr>
<tr>
<td class="ola3" id="pz20-6">81</td>
<td>Don’t mess with drugs, and don’t associate with those who do.</td>
</tr>
<tr>
<td class="ola3" id="pz20-7">82</td>
<td>Avoid sarcastic remarks.</td>
</tr>
<tr>
<td class="ola3" id="pz21-1">83</td>
<td>In business and in family relationships, remember that the most important thing is trust.</td>
</tr>
<tr>
<td class="ola3" id="pz21-2">84</td>
<td>Forget the Joneses.</td>
</tr>
<tr>
<td class="ola3" id="pz21-3">85</td>
<td>Never encourage anyone to become a lawyer.</td>
</tr>
<tr>
<td class="ola3" id="pz21-4">86</td>
<td>Don’t smoke.</td>
</tr>
<tr>
<td class="ola3" id="pz21-5">87</td>
<td>Even if you’re financially well-to-do, have your children earn and pay part of their college tuition.</td>
</tr>
<tr>
<td class="ola3" id="pz21-6">88</td>
<td>Even if you’re financially well-to-do, have your children earn and pay for <em>all</em> their automobile insurance.</td>
</tr>
<tr>
<td class="ola3" id="pz22-1">89</td>
<td>Recycle old newspapers, bottles, and cans.</td>
</tr>
<tr>
<td class="ola3" id="pz22-2">90</td>
<td>Refill ice cube trays.</td>
</tr>
<tr>
<td class="ola3" id="pz22-3">91</td>
<td>Never invest more in the stock market than you can afford to lose.</td>
</tr>
<tr>
<td class="ola3" id="pz22-4">92</td>
<td>Choose your life’s mate carefully. From this one decision will come ninety percent of all your happiness or misery.</td>
</tr>
<tr>
<td class="ola3" id="pz22-5">93</td>
<td>Make it a habit to do nice things for people who’ll never find it out.</td>
</tr>
<tr>
<td class="ola3" id="pz22-6">94</td>
<td>Lend only those books you never care to see again.</td>
</tr>
<tr>
<td class="ola3" id="pz23-1">95</td>
<td>Don’t let anyone ever see you tipsy.</td>
</tr>
<tr>
<td class="ola3" id="pz23-2">96</td>
<td>Attend class reunions.</td>
</tr>
<tr>
<td class="ola3" id="pz23-3">97</td>
<td>Always have something beautiful in sight, even if it’s just a daisy in a jelly glass.</td>
</tr>
<tr>
<td class="ola3" id="pz23-4">98</td>
<td>Know how to type.</td>
</tr>
<tr>
<td class="ola3" id="pz23-5">99</td>
<td>Read the Bill of Rights.</td>
</tr>
<tr>
<td class="ola3" id="pz23-6">100</td>
<td>Learn how to read a financial report.</td>
</tr>
<tr>
<td class="ola3" id="pz23-7">101</td>
<td>Tell your kids often how terrific they are and that you trust them.</td>
</tr>
<tr>
<td class="ola3" id="pz23-9">102</td>
<td>Take a brisk thirty-minute walk every day.</td>
</tr>
<tr>
<td class="ola3" id="pz24-1">103</td>
<td>
<span class="tb_2">Think big thoughts, but relish small pleasures.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz25-1">104</td>
<td>Use credit cards only for convenience, never for credit.</td>
</tr>
<tr>
<td class="ola3" id="pz25-2">105</td>
<td>Treat yourself to a massage on your birthday.</td>
</tr>
<tr>
<td class="ola3" id="pz25-3">106</td>
<td>Never cheat.</td>
</tr>
<tr>
<td class="ola3" id="pz25-4">107</td>
<td>Smile a lot. It costs nothing and is beyond price.</td>
</tr>
<tr>
<td class="ola3" id="pz25-5">108</td>
<td>Know how to drive a stick shift.</td>
</tr>
<tr>
<td class="ola3" id="pz25-6">109</td>
<td>Spread crunchy peanut butter on Pepperidge Farm Gingerman cookies for the perfect late-night snack.</td>
</tr>
<tr>
<td class="ola3" id="pz25-7">110</td>
<td>Never use profanity.</td>
</tr>
<tr>
<td class="ola3" id="pz26-1">111</td>
<td>When dining with clients or business associates, never order more than one cocktail or one glass of wine. If no one else is drinking, don’t drink at all.</td>
</tr>
<tr>
<td class="ola3" id="pz26-2">112</td>
<td>Never argue with police officers, and address them as “officer.”</td>
</tr>
<tr>
<td class="ola3" id="pz26-3">113</td>
<td>Learn to identify local wildflowers, birds, and trees.</td>
</tr>
<tr>
<td class="ola3" id="pz26-4">114</td>
<td>Keep a fire extinguisher in your kitchen and car.</td>
</tr>
<tr>
<td class="ola3" id="pz26-5">115</td>
<td>Give yourself a year and read the Bible cover to cover.</td>
</tr>
<tr>
<td class="ola3" id="pz27-1">116</td>
<td>Consider writing a living will.</td>
</tr>
<tr>
<td class="ola3" id="pz27-2">117</td>
<td>Install dead bolt locks on outside doors.</td>
</tr>
<tr>
<td class="ola3" id="pz27-3">118</td>
<td>Don’t buy expensive wine, luggage, or watches.</td>
</tr>
<tr>
<td class="ola3" id="pz27-4">119</td>
<td>Put a lot of little marshmallows in your hot chocolate.</td>
</tr>
<tr>
<td class="ola3" id="pz27-6">120</td>
<td>Learn CPR.</td>
</tr>
<tr>
<td class="ola3" id="pz27-7">121</td>
<td>Resist the temptation to buy a boat.</td>
</tr>
<tr>
<td class="ola3" id="pz27-8">122</td>
<td>Stop and read historical roadside markers.</td>
</tr>
<tr>
<td class="ola3" id="pz27-9">123</td>
<td>Respect your children’s privacy. Knock before entering their room.</td>
</tr>
<tr>
<td class="ola3" id="pz28-1">124</td>
<td>
<span class="tb_2">Learn to listen. Opportunity sometimes knocks very softly.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz29-1">125</td>
<td>Know how to change a tire.</td>
</tr>
<tr>
<td class="ola3" id="pz29-2">126</td>
<td>Know how to tie a bow tie.</td>
</tr>
<tr>
<td class="ola3" id="pz29-3">127</td>
<td>Wear audacious underwear under the most solemn business attire.</td>
</tr>
<tr>
<td class="ola3" id="pz29-5">128</td>
<td>Remember people’s names.</td>
</tr>
<tr>
<td class="ola3" id="pz29-6">129</td>
<td>Introduce yourself to the manager where you bank. It’s important that he or she knows you personally.</td>
</tr>
<tr>
<td class="ola3" id="pz29-9">130</td>
<td>Learn the capitals of the states.</td>
</tr>
<tr>
<td class="ola3" id="pz29-10">131</td>
<td>Visit Washington, D.C., and do the tourist bit.</td>
</tr>
<tr>
<td class="ola3" id="pz30-1">132</td>
<td>Leave the toilet seat in the down position.</td>
</tr>
<tr>
<td class="ola3" id="pz30-2">133</td>
<td>When someone is relating an important event that’s happened to them, don’t try to top them with a story of your own. Let them have the stage.</td>
</tr>
<tr>
<td class="ola3" id="pz30-6">134</td>
<td>Have crooked teeth straightened.</td>
</tr>
<tr>
<td class="ola3" id="pz30-7">135</td>
<td>Have dull-colored teeth whitened.</td>
</tr>
<tr>
<td class="ola3" id="pz30-8">136</td>
<td>Keep your watch five minutes fast.</td>
</tr>
<tr>
<td class="ola3" id="pz30-9">137</td>
<td>Learn Spanish. In a few years, more than thirty-five percent of all Americans will speak it as their first language.</td>
</tr>
<tr>
<td class="ola3" id="pz31-1">138</td>
<td>
<span class="tb_2">Never deprive someone of hope; it might be all they have.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz32-1">139</td>
<td>When starting out, don’t worry about not having enough money. Limited funds are a blessing, not a curse. Nothing encourages creative thinking in quite the same way.</td>
</tr>
<tr>
<td class="ola3" id="pz32-2">140</td>
<td>Give yourself an hour to cool off before responding to someone who has provoked you. If it involves something really important, give yourself overnight.</td>
</tr>
<tr>
<td class="ola3" id="pz32-3">141</td>
<td>Keep a flashlight and extra batteries under the bed and in the glove box of your car.</td>
</tr>
<tr>
<td class="ola3" id="pz32-4">142</td>
<td>Don’t buy cheap tools. Craftsman tools from Sears are among the best.</td>
</tr>
<tr>
<td class="ola3" id="pz33-1">143</td>
<td>Pay your bills on time.</td>
</tr>
<tr>
<td class="ola3" id="pz33-2">144</td>
<td>Join a slow-pitch softball league.</td>
</tr>
<tr>
<td class="ola3" id="pz33-3">145</td>
<td>Take someone bowling.</td>
</tr>
<tr>
<td class="ola3" id="pz33-4">146</td>
<td>When playing games with children, let them win.</td>
</tr>
<tr>
<td class="ola3" id="pz33-6">147</td>
<td>Turn off the television at dinner time.</td>
</tr>
<tr>
<td class="ola3" id="pz33-7">148</td>
<td>Learn to handle a pistol and rifle safely.</td>
</tr>
<tr>
<td class="ola3" id="pz33-8">149</td>
<td>Skip one meal a week and give what you would have spent to a street person.</td>
</tr>
<tr>
<td class="ola3" id="pz33-9">150</td>
<td>Sing in a choir.</td>
</tr>
<tr>
<td class="ola3" id="pz34-1">151</td>
<td>Get acquainted with a good lawyer, accountant, and plumber.</td>
</tr>
<tr>
<td class="ola3" id="pz34-2">152</td>
<td>Fly Old Glory on the Fourth of July.</td>
</tr>
<tr>
<td class="ola3" id="pz34-3">153</td>
<td>Stand at attention and put your hand over your heart when singing the national anthem.</td>
</tr>
<tr>
<td class="ola3" id="pz34-4">154</td>
<td>Resist the temptation to put a cute message on your answering machine.</td>
</tr>
<tr>
<td class="ola3" id="pz34-5">155</td>
<td>Have a will and tell your next-of-kin where it is.</td>
</tr>
<tr>
<td class="ola3" id="pz34-6">156</td>
<td>Strive for excellence, not perfection.</td>
</tr>
<tr>
<td class="ola3" id="pz34-7">157</td>
<td>Take time to smell the roses.</td>
</tr>
<tr>
<td class="ola3" id="pz35-1">158</td>
<td>Pray not for things, but for wisdom and courage.</td>
</tr>
<tr>
<td class="ola3" id="pz35-2">159</td>
<td>Be tough minded but tenderhearted.</td>
</tr>
<tr>
<td class="ola3" id="pz35-3">160</td>
<td>Use seat belts.</td>
</tr>
<tr>
<td class="ola3" id="pz35-4">161</td>
<td>Have regular medical and dental checkups.</td>
</tr>
<tr>
<td class="ola3" id="pz35-5">162</td>
<td>Keep your desk and work area neat.</td>
</tr>
<tr>
<td class="ola3" id="pz35-6">163</td>
<td>Take an overnight train trip and sleep in a Pullman.</td>
</tr>
<tr>
<td class="ola3" id="pz35-8">164</td>
<td>Be punctual and insist on it in others.</td>
</tr>
<tr>
<td class="ola3" id="pz35-9">165</td>
<td>Don’t scrimp in order to leave money to your children.</td>
</tr>
<tr>
<td class="ola3" id="pz36-1">166</td>
<td>Don’t waste time responding to your critics.</td>
</tr>
<tr>
<td class="ola3" id="pz36-2">167</td>
<td>Avoid negative people.</td>
</tr>
<tr>
<td class="ola3" id="pz36-3">168</td>
<td>Resist telling people how something should be done. Instead, tell them <em>what</em> needs to be done. They will often surprise you with creative solutions.</td>
</tr>
<tr>
<td class="ola3" id="pz36-4">169</td>
<td>Be original.</td>
</tr>
<tr>
<td class="ola3" id="pz36-5">170</td>
<td>Be neat.</td>
</tr>
<tr>
<td class="ola3" id="pz36-6">171</td>
<td>Never give up on what you really want to do. The person with big dreams is more powerful than one with all the facts.</td>
</tr>
<tr>
<td class="ola3" id="pz37-1">172</td>
<td>
<span class="tb_2">Be kinder than necessary.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz38-1">173</td>
<td>Be suspicious of all politicians.</td>
</tr>
<tr>
<td class="ola3" id="pz38-2">174</td>
<td>Encourage your children to have a part-time job after the age of sixteen.</td>
</tr>
<tr>
<td class="ola3" id="ALn">175</td>
<td>Give people a second chance, but not a third.</td>
</tr>
<tr>
<td class="ola3" id="pz38-5">176</td>
<td>Read carefully anything that requires your signature. Remember the big print giveth and the small print taketh away.</td>
</tr>
<tr>
<td class="ola3" id="pz38-6">177</td>
<td>Learn to recognize the inconsequential; then ignore it.</td>
</tr>
<tr>
<td class="ola3" id="pz38-7">178</td>
<td>Do battle against prejudice and discrimination wherever you find it.</td>
</tr>
<tr>
<td class="ola3" id="pz39-1">179</td>
<td>Never take action when you’re angry.</td>
</tr>
<tr>
<td class="ola3" id="pz39-2">180</td>
<td>Be your wife’s best friend.</td>
</tr>
<tr>
<td class="ola3" id="pz39-3">181</td>
<td>Be romantic.</td>
</tr>
<tr>
<td class="ola3" id="pz39-4">182</td>
<td>Let people know what you stand for—and what you won’t stand for.</td>
</tr>
<tr>
<td class="ola3" id="pz39-6">183</td>
<td>Don’t quit a job until you’ve lined up another.</td>
</tr>
<tr>
<td class="ola3" id="pz39-7">184</td>
<td>Never criticize the person who signs your paycheck. If you are unhappy with your job, resign.</td>
</tr>
<tr>
<td class="ola3" id="pz39-8">185</td>
<td>Wear out, don’t rust out.</td>
</tr>
<tr>
<td class="ola3" id="pz40-1">186</td>
<td>
<span class="tb_2">Become the most positive and enthusiastic person you know.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz41-1">187</td>
<td>Be insatiably curious. Ask “why” a lot.</td>
</tr>
<tr>
<td class="ola3" id="pz41-2">188</td>
<td>Measure people by the size of their hearts, not the size of their bank accounts.</td>
</tr>
<tr>
<td class="ola3" id="pz41-3">189</td>
<td>Have good posture. Enter a room with purpose and confidence.</td>
</tr>
<tr>
<td class="ola3" id="pz41-4">190</td>
<td>Don’t worry that you can’t give your kids the best of everything. Give them <em>your</em> very best.</td>
</tr>
<tr>
<td class="ola3" id="pz41-5">191</td>
<td>Drink low fat milk.</td>
</tr>
<tr>
<td class="ola3" id="pz41-6">192</td>
<td>Use less salt.</td>
</tr>
<tr>
<td class="ola3" id="pz41-7">193</td>
<td>Eat less red meat.</td>
</tr>
<tr>
<td class="ola3" id="pz42-1">194</td>
<td>Learn how to fix a leaky faucet and toilet.</td>
</tr>
<tr>
<td class="ola3" id="pz42-2">195</td>
<td>Determine the quality of a neighborhood by the manners of the people living there.</td>
</tr>
<tr>
<td class="ola3" id="pz42-3">196</td>
<td>Surprise a new neighbor with one of your favorite homemade dishes—and include the recipe.</td>
</tr>
<tr>
<td class="ola3" id="pz42-4">197</td>
<td>Don’t forget, a person’s greatest emotional need is to feel appreciated.</td>
</tr>
<tr>
<td class="ola3" id="pz42-5">198</td>
<td>Feed a stranger’s expired parking meter.</td>
</tr>
<tr>
<td class="ola3" id="pz42-6">199</td>
<td>Park at the back of the lot at shopping centers. The walk is good exercise.</td>
</tr>
<tr>
<td class="ola3" id="pz43-1">200</td>
<td>Don’t watch violent television shows, and don’t buy the products that sponsor them.</td>
</tr>
<tr>
<td class="ola3" id="pz43-2">201</td>
<td>Don’t carry a grudge.</td>
</tr>
<tr>
<td class="ola3" id="pz43-3">202</td>
<td>Show respect for all living things.</td>
</tr>
<tr>
<td class="ola3" id="pz43-4">203</td>
<td>Return borrowed vehicles with the gas tank full.</td>
</tr>
<tr>
<td class="ola3" id="pz43-5">204</td>
<td>Choose work that is in harmony with your values.</td>
</tr>
<tr>
<td class="ola3" id="pz43-6">205</td>
<td>Loosen up. Relax. Except for rare life-and-death matters, nothing is as important as it first seems.</td>
</tr>
<tr>
<td class="ola3" id="pz43-7">206</td>
<td>Swing for the fence.</td>
</tr>
<tr>
<td class="ola3" id="pz44-1">207</td>
<td>
<span class="tb_2">Commit yourself to constant self-improvement.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz45-1">208</td>
<td>Give your best to your employer. It’s one of the best investments you can make.</td>
</tr>
<tr>
<td class="ola3" id="pz45-2">209</td>
<td>Attend high school art shows, and always buy something.</td>
</tr>
<tr>
<td class="ola3" id="pz45-3">210</td>
<td>Observe the speed limit.</td>
</tr>
<tr>
<td class="ola3" id="pz45-4">211</td>
<td>Take your dog to obedience school. You’ll both learn a lot.</td>
</tr>
<tr>
<td class="ola3" id="pz45-5">212</td>
<td>Don’t waste time grieving over past mistakes. Learn from them and move on.</td>
</tr>
<tr>
<td class="ola3" id="pz45-6">213</td>
<td>When complimented, a sincere “thank you” is the only response required.</td>
</tr>
<tr>
<td class="ola3" id="pz46-1">214</td>
<td>Don’t plan a long evening on a blind date. A lunch date is perfect. If things don’t work out, both of you have wasted only an hour.</td>
</tr>
<tr>
<td class="ola3" id="pz46-2">215</td>
<td>Don’t discuss business in elevators. You never know who may overhear you.</td>
</tr>
<tr>
<td class="ola3" id="pz46-3">216</td>
<td>Be a good loser.</td>
</tr>
<tr>
<td class="ola3" id="pz46-4">217</td>
<td>Be a good winner.</td>
</tr>
<tr>
<td class="ola3" id="pz46-5">218</td>
<td>Never go grocery shopping when you’re hungry. You’ll buy too much.</td>
</tr>
<tr>
<td class="ola3" id="pz46-7">219</td>
<td>Spend less time worrying <em>who’s</em> right, and more time deciding <em>what’s</em> right.</td>
</tr>
<tr>
<td class="ola3" id="pz47-1">220</td>
<td>
<span class="tb_2">Don’t major in minor things.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz48-1">221</td>
<td>Don’t allow the phone to interrupt important moments. It’s there for your convenience, not the caller’s.</td>
</tr>
<tr>
<td class="ola3" id="pz48-2">222</td>
<td>Think twice before burdening a friend with a secret.</td>
</tr>
<tr>
<td class="ola3" id="pz48-3">223</td>
<td>Praise in public.</td>
</tr>
<tr>
<td class="ola3" id="pz48-4">224</td>
<td>Criticize in private.</td>
</tr>
<tr>
<td class="ola3" id="pz48-5">225</td>
<td>When someone hugs you, let them be the first to let go.</td>
</tr>
<tr>
<td class="ola3" id="pz48-6">226</td>
<td>Resist giving advice concerning matrimony, finances, or hair styles.</td>
</tr>
<tr>
<td class="ola3" id="pz49-1">227</td>
<td>Never tell anyone they look tired or depressed.</td>
</tr>
<tr>
<td class="ola3" id="pz49-2">228</td>
<td>Have impeccable manners.</td>
</tr>
<tr>
<td class="ola3" id="pz49-3">229</td>
<td>Never pay for work before it’s completed.</td>
</tr>
<tr>
<td class="ola3" id="pz49-4">230</td>
<td>Keep good company.</td>
</tr>
<tr>
<td class="ola3" id="pz49-5">231</td>
<td>Keep a daily journal.</td>
</tr>
<tr>
<td class="ola3" id="pz49-6">232</td>
<td>Keep your promises.</td>
</tr>
<tr>
<td class="ola3" id="pz49-7">233</td>
<td>Avoid any church that has cushions on the pews and is considering building a gymnasium.</td>
</tr>
<tr>
<td class="ola3" id="pz49-8">234</td>
<td>Teach your children the value of money and the importance of saving.</td>
</tr>
<tr>
<td class="ola3" id="pz50-1">235</td>
<td>Be willing to lose a battle in order to win the war.</td>
</tr>
<tr>
<td class="ola3" id="pz50-2">236</td>
<td>Don’t be deceived by first impressions.</td>
</tr>
<tr>
<td class="ola3" id="pz50-3">237</td>
<td>Seek out the good in people.</td>
</tr>
<tr>
<td class="ola3" id="pz50-4">238</td>
<td>Don’t encourage rude or inattentive service by tipping the standard amount.</td>
</tr>
<tr>
<td class="ola3" id="pz50-5">239</td>
<td>Watch the movie <em>It’s a Wonderful Life</em> every Christmas.</td>
</tr>
<tr>
<td class="ola3" id="pz50-6">240</td>
<td>Drink eight glasses of water every day.</td>
</tr>
<tr>
<td class="ola3" id="pz50-7">241</td>
<td>Respect tradition.</td>
</tr>
<tr>
<td class="ola3" id="pz51-1">242</td>
<td>
<span class="tb_2">Never cut what can be untied.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz52-1">243</td>
<td>Be cautious about lending money to friends. You might lose both.</td>
</tr>
<tr>
<td class="ola3" id="pz52-2">244</td>
<td>Never waste an opportunity to tell good employees how much they mean to the company.</td>
</tr>
<tr>
<td class="ola3" id="pz52-3">245</td>
<td>Buy a bird feeder and hang it so that you can see it from your kitchen window.</td>
</tr>
<tr>
<td class="ola3" id="pz52-4">246</td>
<td>Wave at children on school buses.</td>
</tr>
<tr>
<td class="ola3" id="pz52-5">247</td>
<td>Show respect for others’ time. Call whenever you’re going to be more than ten minutes late for an appointment.</td>
</tr>
<tr>
<td class="ola3" id="pz53-1">248</td>
<td>Tape record your parents’ memories of how they met and their first years of marriage.</td>
</tr>
<tr>
<td class="ola3" id="pz53-2">249</td>
<td>Hire people smarter than you.</td>
</tr>
<tr>
<td class="ola3" id="pz53-3">250</td>
<td>Be modest. A lot was accomplished before you were born.</td>
</tr>
<tr>
<td class="ola3" id="pz53-4">251</td>
<td>Take good care of those you love.</td>
</tr>
<tr>
<td class="ola3" id="pz53-5">252</td>
<td>Keep it simple.</td>
</tr>
<tr>
<td class="ola3" id="pz53-6">253</td>
<td>Purchase gas from the neighborhood gas station even if it costs more. Next winter when it’s six degrees and your car won’t start, you’ll be glad they know you.</td>
</tr>
<tr>
<td class="ola3" id="pz54-1">254</td>
<td>Learn to show enthusiasm, even when you don’t feel like it.</td>
</tr>
<tr>
<td class="ola3" id="pz54-2">255</td>
<td>Learn to show cheerfulness, even when you don’t feel like it.</td>
</tr>
<tr>
<td class="ola3" id="pz54-3">256</td>
<td>Don’t jaywalk.</td>
</tr>
<tr>
<td class="ola3" id="pz54-4">257</td>
<td>Never ask a lawyer or accountant for business advice. They are trained to find problems, not solutions.</td>
</tr>
<tr>
<td class="ola3" id="pz54-7">258</td>
<td>Avoid like the plague any lawsuit.</td>
</tr>
<tr>
<td class="ola3" id="pz54-8">259</td>
<td>Take family vacations whether you can afford them or not. The memories will be priceless.</td>
</tr>
<tr>
<td class="ola3" id="pz55-1">260</td>
<td>Every day show your family how much you love them with your words, with your touch, and with your thoughtfulness.</td>
</tr>
<tr>
<td class="ola3" id="pz55-2">261</td>
<td>Don’t gossip.</td>
</tr>
<tr>
<td class="ola3" id="pz55-3">262</td>
<td>Don’t discuss salaries.</td>
</tr>
<tr>
<td class="ola3" id="pz55-4">263</td>
<td>Don’t nag.</td>
</tr>
<tr>
<td class="ola3" id="pz55-5">264</td>
<td>Don’t gamble.</td>
</tr>
<tr>
<td class="ola3" id="pz55-6">265</td>
<td>Beware of the person who has nothing to lose.</td>
</tr>
<tr>
<td class="ola3" id="pz55-7">266</td>
<td>Lie on your back and look at the stars.</td>
</tr>
<tr>
<td class="ola3" id="pz55-8">267</td>
<td>Don’t leave car keys in the ignition.</td>
</tr>
<tr>
<td class="ola3" id="pz56-1">268</td>
<td>When meeting someone for the first time, resist asking what they do for a living. Enjoy their company without attaching any labels.</td>
</tr>
<tr>
<td class="ola3" id="pz56-2">269</td>
<td>Don’t whine.</td>
</tr>
<tr>
<td class="ola3" id="pz56-3">270</td>
<td>Arrive at work early and stay beyond quitting time.</td>
</tr>
<tr>
<td class="ola3" id="pz56-4">271</td>
<td>When facing a difficult task, act as though it is impossible to fail. If you’re going after Moby Dick, take along the tartar sauce.</td>
</tr>
<tr>
<td class="ola3" id="pz56-5">272</td>
<td>Change air conditioner filters every three months.</td>
</tr>
<tr>
<td class="ola3" id="pz57-1">273</td>
<td>
<span class="tb_2">Leave everything a little better than you found it.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz58-1">274</td>
<td>Remember that overnight success usually takes about fifteen years.</td>
</tr>
<tr>
<td class="ola3" id="pz58-2">275</td>
<td>Cut out complimentary newspaper articles about people you know and mail the articles to them with notes of congratulations.</td>
</tr>
<tr>
<td class="ola3" id="pz58-3">276</td>
<td>Patronize local merchants even if it costs a bit more.</td>
</tr>
<tr>
<td class="ola3" id="pz58-4">277</td>
<td>Fill your gas tank when it falls below one-quarter full.</td>
</tr>
<tr>
<td class="ola3" id="pz58-5">278</td>
<td>Never snap your fingers to get someone’s attention. It’s rude.</td>
</tr>
<tr>
<td class="ola3" id="pz59-1">279</td>
<td>Don’t expect money to bring you happiness.</td>
</tr>
<tr>
<td class="ola3" id="pz59-2">280</td>
<td>No matter how dire the situation, keep your cool.</td>
</tr>
<tr>
<td class="ola3" id="pz59-3">281</td>
<td>When paying cash, ask for a discount.</td>
</tr>
<tr>
<td class="ola3" id="pz59-4">282</td>
<td>Find a good tailor.</td>
</tr>
<tr>
<td class="ola3" id="pz59-5">283</td>
<td>Don’t use a toothpick in public.</td>
</tr>
<tr>
<td class="ola3" id="pz59-6">284</td>
<td>Never underestimate your power to change yourself.</td>
</tr>
<tr>
<td class="ola3" id="pz59-7">285</td>
<td>Never overestimate your power to change others.</td>
</tr>
<tr>
<td class="ola3" id="pz60-1">286</td>
<td>Practice empathy. Try to see things from other people’s point of view.</td>
</tr>
<tr>
<td class="ola3" id="pz60-2">287</td>
<td>Promise big. Deliver big.</td>
</tr>
<tr>
<td class="ola3" id="pz60-3">288</td>
<td>Discipline yourself to save money. It’s essential to success.</td>
</tr>
<tr>
<td class="ola3" id="pz60-4">289</td>
<td>Find some other way of proving your manhood than by shooting defenseless animals and birds.</td>
</tr>
<tr>
<td class="ola3" id="pz60-5">290</td>
<td>Remember the deal’s not done until the check has cleared the bank.</td>
</tr>
<tr>
<td class="ola3" id="pz60-6">291</td>
<td>Don’t burn bridges. You’ll be surprised how many times you have to cross the same river.</td>
</tr>
<tr>
<td class="ola3" id="pz61-1">292</td>
<td>Don’t spread yourself too thin. Learn to say <em>no</em> politely and quickly.</td>
</tr>
<tr>
<td class="ola3" id="pz61-2">293</td>
<td>Keep overhead low.</td>
</tr>
<tr>
<td class="ola3" id="pz61-3">294</td>
<td>Keep expectations high.</td>
</tr>
<tr>
<td class="ola3" id="pz61-4">295</td>
<td>Remember that a successful marriage depends on two things: (1) finding the right person and (2) being the right person.</td>
</tr>
<tr>
<td class="ola3" id="pz61-5">296</td>
<td>See problems as opportunities for growth and self-mastery.</td>
</tr>
<tr>
<td class="ola3" id="pz61-6">297</td>
<td>Don’t believe people when they ask you to be honest with them.</td>
</tr>
<tr>
<td class="ola3" id="pz62-1">298</td>
<td>Get and stay in shape.</td>
</tr>
<tr>
<td class="ola3" id="pz62-2">299</td>
<td>Accept pain and disappointment as part of life.</td>
</tr>
<tr>
<td class="ola3" id="pz62-3">300</td>
<td>Don’t expect life to be fair.</td>
</tr>
<tr>
<td class="ola3" id="pz62-4">301</td>
<td>Become an expert in time management.</td>
</tr>
<tr>
<td class="ola3" id="pz62-5">302</td>
<td>Lock your car even if it’s parked in your own driveway.</td>
</tr>
<tr>
<td class="ola3" id="pz62-6">303</td>
<td>Never go to bed with dirty dishes in the sink.</td>
</tr>
<tr>
<td class="ola3" id="pz62-7">304</td>
<td>Learn to handle a handsaw and a hammer.</td>
</tr>
<tr>
<td class="ola3" id="pz62-8">305</td>
<td>Compliment the meal when you’re a guest in someone’s home.</td>
</tr>
<tr>
<td class="ola3" id="pz63-1">306</td>
<td>
<span class="tb_2">Judge your success by the degree that you’re enjoying peace, health, and love.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz64-1">307</td>
<td>Take a nap on Sunday afternoons.</td>
</tr>
<tr>
<td class="ola3" id="pz64-2">308</td>
<td>Make the bed when you’re an overnight visitor in someone’s home.</td>
</tr>
<tr>
<td class="ola3" id="pz64-3">309</td>
<td>Contribute five percent of your income to charity.</td>
</tr>
<tr>
<td class="ola3" id="pz64-4">310</td>
<td>Don’t leave a ring in the bathtub.</td>
</tr>
<tr>
<td class="ola3" id="pz64-5">311</td>
<td>When tempted to criticize your parents, spouse, or children, bite your tongue.</td>
</tr>
<tr>
<td class="ola3" id="pz64-6">312</td>
<td>Never underestimate the power of love.</td>
</tr>
<tr>
<td class="ola3" id="pz64-7">313</td>
<td>Never underestimate the power of forgiveness.</td>
</tr>
<tr>
<td class="ola3" id="pz65-1">314</td>
<td>Don’t waste time playing cards.</td>
</tr>
<tr>
<td class="ola3" id="pz65-2">315</td>
<td>Don’t bore people with your problems. When someone asks you how you feel—say, “Terrific, never better.” When they ask, “How’s business?” reply, “Excellent, and getting better every day.”</td>
</tr>
<tr>
<td class="ola3" id="pz65-3">316</td>
<td>Learn to disagree without being disagreeable.</td>
</tr>
<tr>
<td class="ola3" id="pz65-4">317</td>
<td>Be tactful. Never alienate anyone on purpose.</td>
</tr>
<tr>
<td class="ola3" id="pz65-5">318</td>
<td>Hear both sides before judging.</td>
</tr>
<tr>
<td class="ola3" id="pz65-6">319</td>
<td>Be courteous to everyone.</td>
</tr>
<tr>
<td class="ola3" id="pz65-7">320</td>
<td>Wave to crosswalk patrol mothers.</td>
</tr>
<tr>
<td class="ola3" id="pz66-1">321</td>
<td>Refrain from envy. It’s the source of much unhappiness.</td>
</tr>
<tr>
<td class="ola3" id="pz66-2">322</td>
<td>Don’t say you don’t have enough time. You have exactly the same number of hours per day that were given to Helen Keller, Pasteur, Michelangelo, Mother Teresa, Leonardo da Vinci, Thomas Jefferson, and Albert Einstein.</td>
</tr>
<tr>
<td class="ola3" id="pz66-3">323</td>
<td>When there’s no time for a full work-out, do push-ups.</td>
</tr>
<tr>
<td class="ola3" id="pz66-4">324</td>
<td>Don’t delay acting on a good idea. Chances are someone else has just thought of it, too. Success comes to the one who acts first.</td>
</tr>
<tr>
<td class="ola3" id="pz67-1">325</td>
<td>Be wary of people who tell you how honest they are.</td>
</tr>
<tr>
<td class="ola3" id="pz67-2">326</td>
<td>Remember that winners do what losers don’t want to do.</td>
</tr>
<tr>
<td class="ola3" id="pz67-3">327</td>
<td>Rekindle old friendships.</td>
</tr>
<tr>
<td class="ola3" id="pz67-4">328</td>
<td>When traveling, put a card in your wallet with your name, home phone, the phone number of a friend or close relative, important medical information, plus the phone number of the hotel or motel where you’re staying.</td>
</tr>
<tr>
<td class="ola3" id="pz67-9">329</td>
<td>Every so often push your luck.</td>
</tr>
<tr>
<td class="ola3" id="pz68-1">330</td>
<td>
<span class="tb_2">Live your life as an exclamation, not an explanation.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz69-1">331</td>
<td>When you arrive at your job in the morning, let the first thing you say brighten everyone’s day.</td>
</tr>
<tr>
<td class="ola3" id="pz69-2">332</td>
<td>Seek opportunity, not security. A boat in a harbor is safe, but in time its bottom will rot out.</td>
</tr>
<tr>
<td class="ola3" id="pz69-3">333</td>
<td>Instead of using the words, <em>if only,</em> try substituting the words, <em>next time.</em>
</td>
</tr>
<tr>
<td class="ola3" id="pz69-4">334</td>
<td>Instead of using the word <em>problem,</em> try substituting the word <em>opportunity.</em>
</td>
</tr>
<tr>
<td class="ola3" id="pz69-5">335</td>
<td>Reread your favorite book.</td>
</tr>
<tr>
<td class="ola3" id="pz69-6">336</td>
<td>Live your life so that your epitaph could read, “No regrets.”</td>
</tr>
<tr>
<td class="ola3" id="pz70-1">337</td>
<td>Install smoke detectors in your home.</td>
</tr>
<tr>
<td class="ola3" id="pz70-2">338</td>
<td>Get your next pet from the animal shelter.</td>
</tr>
<tr>
<td class="ola3" id="pz70-3">339</td>
<td>Don’t think a higher price always means higher quality.</td>
</tr>
<tr>
<td class="ola3" id="pz70-4">340</td>
<td>Don’t be fooled. If something sounds too good to be true, it probably is.</td>
</tr>
<tr>
<td class="ola3" id="pz70-5">341</td>
<td>When renting a car for a couple of days, splurge and get the big Lincoln.</td>
</tr>
<tr>
<td class="ola3" id="pz70-6">342</td>
<td>Regarding furniture and clothes: if you think you’ll be using them five years or longer, buy the best you can afford.</td>
</tr>
<tr>
<td class="ola3" id="pz71-1">343</td>
<td>Never walk out on a quarrel with your wife.</td>
</tr>
<tr>
<td class="ola3" id="pz71-2">344</td>
<td>Patronize drug stores with soda fountains.</td>
</tr>
<tr>
<td class="ola3" id="pz71-3">345</td>
<td>Try everything offered by supermarket food demonstrators.</td>
</tr>
<tr>
<td class="ola3" id="pz71-4">346</td>
<td>Be bold and courageous. When you look back on your life, you’ll regret the things you didn’t do more than the ones you did.</td>
</tr>
<tr>
<td class="ola3" id="pz71-5">347</td>
<td>Remember the three most important things when buying a home: location, location, location.</td>
</tr>
<tr>
<td class="ola3" id="pz71-6">348</td>
<td>Just for fun, attend a small town Fourth of July celebration.</td>
</tr>
<tr>
<td class="ola3" id="pz72-1">349</td>
<td>
<span class="tb_2">Never waste an opportunity to tell someone you love them.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz73-1">350</td>
<td>Own a good dictionary.</td>
</tr>
<tr>
<td class="ola3" id="pz73-2">351</td>
<td>Own a good thesaurus.</td>
</tr>
<tr>
<td class="ola3" id="pz73-3">352</td>
<td>Keep valuable papers in a bank lockbox.</td>
</tr>
<tr>
<td class="ola3" id="pz73-4">353</td>
<td>Go through all your old photographs. Select ten and tape them to your kitchen cabinets. Change them every thirty days.</td>
</tr>
<tr>
<td class="ola3" id="pz73-7">354</td>
<td>Be there when people need you.</td>
</tr>
<tr>
<td class="ola3" id="pz73-8">355</td>
<td>Let your representatives in Washington know how you feel. Call (202) 225-3121 for the House and (202) 224-3121 for the Senate. An operator will connect you to the right office.</td>
</tr>
<tr>
<td class="ola3" id="pz74-1">356</td>
<td>To explain a romantic break-up, simply say, “It was all my fault.”</td>
</tr>
<tr>
<td class="ola3" id="pz74-2">357</td>
<td>Evaluate yourself by your own standards, not someone else’s.</td>
</tr>
<tr>
<td class="ola3" id="pz74-3">358</td>
<td>Be decisive even if it means you’ll sometimes be wrong.</td>
</tr>
<tr>
<td class="ola3" id="pz74-4">359</td>
<td>Don’t let anyone talk you out of pursuing what you know to be a great idea.</td>
</tr>
<tr>
<td class="ola3" id="pz74-5">360</td>
<td>Be prepared to lose once in a while.</td>
</tr>
<tr>
<td class="ola3" id="pz74-6">361</td>
<td>Don’t flush urinals with your hand—use your elbow.</td>
</tr>
<tr>
<td class="ola3" id="pz75-1">362</td>
<td>Know when to keep silent.</td>
</tr>
<tr>
<td class="ola3" id="pz75-2">363</td>
<td>Know when to speak up.</td>
</tr>
<tr>
<td class="ola3" id="pz75-3">364</td>
<td>Every day look for some small way to improve your marriage.</td>
</tr>
<tr>
<td class="ola3" id="pz75-4">365</td>
<td>Every day look for some small way to improve the way you do your job.</td>
</tr>
<tr>
<td class="ola3" id="pz75-5">366</td>
<td>Acquire things the old-fashioned way: Save for them and pay cash.</td>
</tr>
<tr>
<td class="ola3" id="pz75-6">367</td>
<td>Remember no one makes it alone. Have a grateful heart and be quick to acknowledge those who help you.</td>
</tr>
<tr>
<td class="ola3" id="pz76-1">368</td>
<td>Never eat the last cookie.</td>
</tr>
<tr>
<td class="ola3" id="pz76-2">369</td>
<td>Read <em>Leadership Is an Art</em> by Max DePree (Dell, 1989).</td>
</tr>
<tr>
<td class="ola3" id="pz76-3">370</td>
<td>Do business with those who do business with you.</td>
</tr>
<tr>
<td class="ola3" id="pz76-4">371</td>
<td>Just to see how it feels, for the next twenty-four hours refrain from criticizing anybody or anything.</td>
</tr>
<tr>
<td class="ola3" id="pz76-5">372</td>
<td>Give your clients your enthusiastic best.</td>
</tr>
<tr>
<td class="ola3" id="pz76-6">373</td>
<td>Save an evening a week for just you and your wife.</td>
</tr>
<tr>
<td class="ola3" id="pz77-1">374</td>
<td>
<span class="tb_2">Take charge of your attitude. Don’t let someone else choose it for you.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz78-1">375</td>
<td>Let your children overhear you saying complimentary things about them to other adults.</td>
</tr>
<tr>
<td class="ola3" id="pz78-2">376</td>
<td>Work hard to create in your children a good self-image. It’s the most important thing you can do to insure their success.</td>
</tr>
<tr>
<td class="ola3" id="pz78-3">377</td>
<td>Carry jumper cables in your car.</td>
</tr>
<tr>
<td class="ola3" id="pz78-4">378</td>
<td>Get all repair estimates in writing.</td>
</tr>
<tr>
<td class="ola3" id="pz78-5">379</td>
<td>Forget committees. New, noble, world-changing ideas always come from one person working alone.</td>
</tr>
<tr>
<td class="ola3" id="pz79-1">380</td>
<td>Pay attention to the details.</td>
</tr>
<tr>
<td class="ola3" id="AKK">381</td>
<td>Be a self-starter.</td>
</tr>
<tr>
<td class="ola3" id="pz79-2">382</td>
<td>Be loyal.</td>
</tr>
<tr>
<td class="ola3" id="pz79-3">383</td>
<td>Understand that happiness is not based on possessions, power, or prestige, but on relationships with people you love and respect.</td>
</tr>
<tr>
<td class="ola3" id="pz79-4">384</td>
<td>Never give a loved one a gift that suggests they need improvement.</td>
</tr>
<tr>
<td class="ola3" id="pz79-5">385</td>
<td>Compliment even small improvements.</td>
</tr>
<tr>
<td class="ola3" id="pz79-6">386</td>
<td>Turn off the tap when brushing your teeth.</td>
</tr>
<tr>
<td class="ola3" id="pz80-1">387</td>
<td>Wear expensive shoes, belts, and ties, but buy them on sale.</td>
</tr>
<tr>
<td class="ola3" id="pz80-2">388</td>
<td>When undecided about what color to paint a room, choose antique white.</td>
</tr>
<tr>
<td class="ola3" id="pz80-3">389</td>
<td>Carry stamps in your wallet. You never know when you’ll discover the perfect card for a friend or loved one.</td>
</tr>
<tr>
<td class="ola3" id="pz80-4">390</td>
<td>Street musicians are a treasure. Stop for a moment and listen; then leave a small donation.</td>
</tr>
<tr>
<td class="ola3" id="pz80-5">391</td>
<td>When faced with a serious health problem, get at least three medical opinions.</td>
</tr>
<tr>
<td class="ola3" id="pz81-1">392</td>
<td>Support equal pay for equal work.</td>
</tr>
<tr>
<td class="ola3" id="pz81-2">393</td>
<td>Pay your fair share.</td>
</tr>
<tr>
<td class="ola3" id="pz81-3">394</td>
<td>Learn how to use the internet.</td>
</tr>
<tr>
<td class="ola3" id="pz81-4">395</td>
<td>Remain open, flexible, curious.</td>
</tr>
<tr>
<td class="ola3" id="pz81-5">396</td>
<td>Never give anyone a fruitcake.</td>
</tr>
<tr>
<td class="ola3" id="pz81-6">397</td>
<td>Never acquire just one kitten. Two are a lot more fun and no more trouble.</td>
</tr>
<tr>
<td class="ola3" id="pz81-7">398</td>
<td>Start meetings on time regardless of who’s missing.</td>
</tr>
<tr>
<td class="ola3" id="pz81-8">399</td>
<td>Stay out of nightclubs.</td>
</tr>
<tr>
<td class="ola3" id="pz82-1">400</td>
<td>
<span class="tb_2">Focus on making things better, not bigger.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz83-1">401</td>
<td>Don’t ever watch hot dogs or sausage being made.</td>
</tr>
<tr>
<td class="ola3" id="pz83-2">402</td>
<td>Begin each day with your favorite music.</td>
</tr>
<tr>
<td class="ola3" id="pz83-3">403</td>
<td>Visit your city’s night court on a Saturday night.</td>
</tr>
<tr>
<td class="ola3" id="pz83-4">404</td>
<td>Don’t be intimidated by doctors and nurses. Even when you’re in the hospital, it’s still your body.</td>
</tr>
<tr>
<td class="ola3" id="pz83-5">405</td>
<td>Read hospital bills carefully. It’s reported that 89% contain errors—in favor of the hospital.</td>
</tr>
<tr>
<td class="ola3" id="pz83-6">406</td>
<td>Send a lot of Valentine cards. Sign them, “Someone who thinks you’re terrific.”</td>
</tr>
<tr>
<td class="ola3" id="pz84-1">407</td>
<td>When attending meetings, sit down front.</td>
</tr>
<tr>
<td class="ola3" id="pz84-2">408</td>
<td>Every once in a while, take the scenic route.</td>
</tr>
<tr>
<td class="ola3" id="pz84-3">409</td>
<td>Don’t let your possessions possess you.</td>
</tr>
<tr>
<td class="ola3" id="pz84-4">410</td>
<td>Wage war against littering.</td>
</tr>
<tr>
<td class="ola3" id="pz84-5">411</td>
<td>Cut your own firewood.</td>
</tr>
<tr>
<td class="ola3" id="pz84-6">412</td>
<td>When you and your wife have a disagreement, regardless of who’s wrong, apologize. Say, “I’m sorry I upset you. Would you forgive me?” These are healing, magical words.</td>
</tr>
<tr>
<td class="ola3" id="pz84-7">413</td>
<td>Be enthusiastic about the success of others.</td>
</tr>
<tr>
<td class="ola3" id="pz85-1">414</td>
<td>Don’t flaunt your success, but don’t apologize for it either.</td>
</tr>
<tr>
<td class="ola3" id="pz85-2">415</td>
<td>After experiencing inferior service, food, or products, bring it to the attention of the person in charge. Good managers will appreciate knowing.</td>
</tr>
<tr>
<td class="ola3" id="pz85-3">416</td>
<td>Don’t procrastinate. Do what needs doing when it needs to be done.</td>
</tr>
<tr>
<td class="ola3" id="pz85-4">417</td>
<td>Read to your children.</td>
</tr>
<tr>
<td class="ola3" id="pz85-5">418</td>
<td>Sing to your children.</td>
</tr>
<tr>
<td class="ola3" id="pz85-6">419</td>
<td>Listen to your children.</td>
</tr>
<tr>
<td class="ola3" id="pz86-1">420</td>
<td>
<span class="tb_2">Take care of your reputation. It’s your most valuable asset.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz87-1">421</td>
<td>Get your priorities straight. No one ever said on his death bed, “Gee, if I’d only spent more time at the office.”</td>
</tr>
<tr>
<td class="ola3" id="pz87-2">422</td>
<td>Turn on your headlights when it begins to rain.</td>
</tr>
<tr>
<td class="ola3" id="pz87-3">423</td>
<td>Don’t tailgate.</td>
</tr>
<tr>
<td class="ola3" id="pz87-4">424</td>
<td>Sign and carry your organ donor card.</td>
</tr>
<tr>
<td class="ola3" id="pz87-5">425</td>
<td>Don’t allow self-pity. The moment this emotion strikes, do something nice for someone less fortunate than you.</td>
</tr>
<tr>
<td class="ola3" id="pz87-6">426</td>
<td>Improve your performance by improving your attitude.</td>
</tr>
<tr>
<td class="ola3" id="pz88-1">427</td>
<td>Share the credit.</td>
</tr>
<tr>
<td class="ola3" id="pz88-2">428</td>
<td>Don’t accept “good enough” as good enough.</td>
</tr>
<tr>
<td class="ola3" id="pz88-3">429</td>
<td>Do more than is expected.</td>
</tr>
<tr>
<td class="ola3" id="pz88-4">430</td>
<td>Go to a county fair and check out the 4-H Club exhibits. It will renew your faith in the younger generation.</td>
</tr>
<tr>
<td class="ola3" id="pz88-5">431</td>
<td>Select a doctor your own age so that you can grow old together.</td>
</tr>
<tr>
<td class="ola3" id="pz88-6">432</td>
<td>Make a list of twenty-five things you want to experience before you die. Carry it in your wallet and refer to it often.</td>
</tr>
<tr>
<td class="ola3" id="pz89-1">433</td>
<td>Use club soda as an emergency spot remover.</td>
</tr>
<tr>
<td class="ola3" id="pz89-2">434</td>
<td>Have a friend who owns a truck.</td>
</tr>
<tr>
<td class="ola3" id="pz89-3">435</td>
<td>At the movies, buy Junior Mints and sprinkle them on your popcorn.</td>
</tr>
<tr>
<td class="ola3" id="pz89-4">436</td>
<td>Have some knowledge of three religions other than your own.</td>
</tr>
<tr>
<td class="ola3" id="pz89-5">437</td>
<td>Answer the phone with enthusiasm and energy in your voice.</td>
</tr>
<tr>
<td class="ola3" id="pz89-6">438</td>
<td>Change your car’s oil and filter every three thousand miles regardless of what the owner’s manual recommends.</td>
</tr>
<tr>
<td class="ola3" id="pz90-1">439</td>
<td>Every person that you meet knows something you don’t; learn from them.</td>
</tr>
<tr>
<td class="ola3" id="pz90-2">440</td>
<td>Tape record your parents’ laughter.</td>
</tr>
<tr>
<td class="ola3" id="pz90-3">441</td>
<td>Never put a candy dish next to the phone.</td>
</tr>
<tr>
<td class="ola3" id="pz90-4">442</td>
<td>When meeting someone you don’t know well, extend your hand and give them your name. Never assume they remember you even if you’ve met them before.</td>
</tr>
<tr>
<td class="ola3" id="pz90-5">443</td>
<td>Do it right the first time.</td>
</tr>
<tr>
<td class="ola3" id="pz90-6">444</td>
<td>Laugh a lot. A good sense of humor cures almost all of life’s ills.</td>
</tr>
<tr>
<td class="ola3" id="pz91-1">445</td>
<td>
<span class="tb_2">Never underestimate the power of a kind word or deed.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz92-1">446</td>
<td>Don’t undertip the waiter just because the food is bad; he didn’t cook it.</td>
</tr>
<tr>
<td class="ola3" id="pz92-2">447</td>
<td>Conduct family fire drills. Be sure everyone knows what to do in case the house catches fire.</td>
</tr>
<tr>
<td class="ola3" id="pz92-3">448</td>
<td>Don’t be afraid to say, “I don’t know.”</td>
</tr>
<tr>
<td class="ola3" id="pz92-4">449</td>
<td>Don’t be afraid to say, “I made a mistake.”</td>
</tr>
<tr>
<td class="ola3" id="pz92-5">450</td>
<td>Don’t be afraid to say, “I need help.”</td>
</tr>
<tr>
<td class="ola3" id="pz92-6">451</td>
<td>Don’t be afraid to say, “I’m sorry.”</td>
</tr>
<tr>
<td class="ola3" id="pz92-7">452</td>
<td>Show respect for everyone who works for a living, regardless of how trivial their job.</td>
</tr>
<tr>
<td class="ola3" id="pz93-1">453</td>
<td>Never compromise your integrity.</td>
</tr>
<tr>
<td class="ola3" id="pz93-2">454</td>
<td>Keep a note pad and pencil on your bedside table. Million-dollar ideas sometimes strike at 3 A.M.</td>
</tr>
<tr>
<td class="ola3" id="pz93-3">455</td>
<td>Read the Sunday <em>New York Times</em> to keep informed.</td>
</tr>
<tr>
<td class="ola3" id="pz93-4">456</td>
<td>Send your loved one flowers. Think of a reason later.</td>
</tr>
<tr>
<td class="ola3" id="pz93-5">457</td>
<td>Get organized. If you don’t know where to start, read Stephanie Winston’s <em>Getting Organized</em> (Warner Books, 1978).</td>
</tr>
<tr>
<td class="ola3" id="pz94-1">458</td>
<td>Attend your children’s athletic contests, plays, and recitals.</td>
</tr>
<tr>
<td class="ola3" id="pz94-2">459</td>
<td>When you find a job that’s ideal, take it regardless of the pay. If you’ve got what it takes, your salary will soon reflect your value to the company.</td>
</tr>
<tr>
<td class="ola3" id="pz94-3">460</td>
<td>Look for opportunities to make people feel important.</td>
</tr>
<tr>
<td class="ola3" id="pz94-4">461</td>
<td>Be open to new ideas.</td>
</tr>
<tr>
<td class="ola3" id="pz94-5">462</td>
<td>Don’t miss the magic of the moment by focusing on what’s to come.</td>
</tr>
<tr>
<td class="ola3" id="pz95-1">463</td>
<td>
<span class="tb_2">Don’t use time or words carelessly. Neither can be retrieved.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz96-1">464</td>
<td>When a child falls and skins a knee or elbow, always show concern; then take the time to “kiss it and make it well.”</td>
</tr>
<tr>
<td class="ola3" id="pz96-2">465</td>
<td>When talking to the press, remember they always have the last word.</td>
</tr>
<tr>
<td class="ola3" id="pz96-3">466</td>
<td>Set short-term and long-term goals.</td>
</tr>
<tr>
<td class="ola3" id="pz96-4">467</td>
<td>When planning a trip abroad, read about the places you’ll visit before you go or, better yet, rent a travel video.</td>
</tr>
<tr>
<td class="ola3" id="pz96-5">468</td>
<td>Don’t rain on other people’s parades.</td>
</tr>
<tr>
<td class="ola3" id="pz96-6">469</td>
<td>Stand when greeting a visitor to your office.</td>
</tr>
<tr>
<td class="ola3" id="pz97-1">470</td>
<td>Don’t interrupt.</td>
</tr>
<tr>
<td class="ola3" id="pz97-2">471</td>
<td>Before leaving to meet a flight, call the airline first to be sure it’s on time.</td>
</tr>
<tr>
<td class="ola3" id="pz97-4">472</td>
<td>Enjoy real maple syrup.</td>
</tr>
<tr>
<td class="ola3" id="pz97-5">473</td>
<td>Don’t be rushed into making an important decision. People will understand if you say, “I’d like a little more time to think it over. Can I get back to you tomorrow?”</td>
</tr>
<tr>
<td class="ola3" id="pz97-6">474</td>
<td>Be prepared. You never get a second chance to make a good first impression.</td>
</tr>
<tr>
<td class="ola3" id="pz97-7">475</td>
<td>Give thanks before every meal.</td>
</tr>
<tr>
<td class="ola3" id="pz98-1">476</td>
<td>Don’t expect others to listen to your advice and ignore your example.</td>
</tr>
<tr>
<td class="ola3" id="pz98-2">477</td>
<td>Go the distance. When you accept a task, finish it.</td>
</tr>
<tr>
<td class="ola3" id="pz98-3">478</td>
<td>Don’t insist on running someone else’s life.</td>
</tr>
<tr>
<td class="ola3" id="pz98-4">479</td>
<td>Decide to get up thirty minutes earlier. Do this for a year, and you will add seven and one-half days to your waking world.</td>
</tr>
<tr>
<td class="ola3" id="pz98-5">480</td>
<td>Get into the habit of putting your billfold and car keys in the same place when entering your home.</td>
</tr>
<tr>
<td class="ola3" id="pz99-1">481</td>
<td>
<span class="tb_2">Watch for big problems. They disguise big opportunities.</span>
</td>
</tr>
<tr>
<td class="ola3" id="pz100-1">482</td>
<td>Learn a card trick.</td>
</tr>
<tr>
<td class="ola3" id="pz100-2">483</td>
<td>Steer clear of restaurants that rotate.</td>
</tr>
<tr>
<td class="ola3" id="pz100-3">484</td>
<td>Give people the benefit of the doubt.</td>
</tr>
<tr>
<td class="ola3" id="pz100-4">485</td>
<td>Never admit at work that you’re tired, angry, or bored.</td>
</tr>
<tr>
<td class="ola3" id="pz100-5">486</td>
<td>Respond promptly to R.S.V.P. invitations. If there’s a phone number, call; if not, write a note.</td>
</tr>
<tr>
<td class="ola3" id="pz100-6">487</td>
<td>Take a kid to the zoo.</td>
</tr>
<tr>
<td class="ola3" id="pz100-7">488</td>
<td>Make someone’s day by paying the toll for the person in the car behind you.</td>
</tr>
<tr>
<td class="ola3" id="pz101-1">489</td>
<td>Don’t make the same mistake twice.</td>
</tr>
<tr>
<td class="ola3" id="pz101-2">490</td>
<td>Don’t drive on slick tires.</td>
</tr>
<tr>
<td class="ola3" id="pz101-3">491</td>
<td>Keep an extra key hidden somewhere on your car in case you lock yourself out.</td>
</tr>
<tr>
<td class="ola3" id="pz101-4">492</td>
<td>Put an insulation blanket around your hot water heater to conserve energy.</td>
</tr>
<tr>
<td class="ola3" id="pz101-5">493</td>
<td>Save ten percent of what you earn.</td>
</tr>
<tr>
<td class="ola3" id="pz101-6">494</td>
<td>Never discuss money with people who have much more or much less than you.</td>
</tr>
<tr>
<td class="ola3" id="pz101-7">495</td>
<td>Never buy a beige car.</td>
</tr>
<tr>
<td class="ola3" id="pz102-1">496</td>
<td>Don’t be called out on strikes. Go down swinging.</td>
</tr>
<tr>
<td class="ola3" id="pz102-2">497</td>
<td>Never buy something you don’t need just because it’s on sale.</td>
</tr>
<tr>
<td class="ola3" id="pz102-3">498</td>
<td>Question your goals by asking, “Will this help me become my very best?”</td>
</tr>
<tr>
<td class="ola3" id="pz102-4">499</td>
<td>Cherish your children for what they are, not for what you’d like them to be.</td>
</tr>
<tr>
<td class="ola3" id="pz102-5">500</td>
<td>When negotiating your salary, think of what you want; then ask for ten percent more.</td>
</tr>
<tr>
<td class="ola3" id="pz102-6">501</td>
<td>Keep several irons in the fire.</td>
</tr>
<tr>
<td class="ola3" id="pz103-1">502</td>
<td>After you’ve worked hard to get what you want, take the time to enjoy it.</td>
</tr>
<tr>
<td class="ola3" id="pz103-2">503</td>
<td>Be alert for opportunities to show praise and appreciation.</td>
</tr>
<tr>
<td class="ola3" id="pz103-3">504</td>
<td>Commit yourself to quality.</td>
</tr>
<tr>
<td class="ola3" id="pz103-4">505</td>
<td>Be a leader: Remember the lead sled dog is the only one with a decent view.</td>
</tr>
<tr>
<td class="ola3" id="pz103-5">506</td>
<td>Never underestimate the power of words to heal and reconcile relationships.</td>
</tr>
<tr>
<td class="ola3" id="pz103-6">507</td>
<td>Your mind can only hold one thought at a time. Make it a positive and constructive one.</td>
</tr>
<tr>
<td class="ola3" id="pz104-1">508</td>
<td>Become someone’s hero.</td>
</tr>
<tr>
<td class="ola3" id="pz104-2">509</td>
<td>Marry only for love.</td>
</tr>
<tr>
<td class="ola3" id="pz104-3">510</td>
<td>Count your blessings.</td>
</tr>
<tr>
<td class="ola3" id="pz104-4">511</td>
<td>Call your mother. </td>
</tr>
</tbody></table>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter04.vue?2461375e